/**
 * Apollo Footer wrapper for the app shell.
 * Replaces src/app/ui/Footer/Footer.js (IQVIA rebranding, SAF-13902).
 * Absolute positioning preserves legacy layout spacing with Canvas bottom margin.
 */
import React from 'react';import styled from 'styled-components';
import Footer from 'apollo-react/components/Footer';
import { SHELL_MAX_WIDTH } from '../header/navigationBarConfig';
import { useSparkFooterLinks } from './useSparkFooterLinks';

const FooterContainer = styled.div`
    position: absolute;
    bottom: 0;
    background-color: #fff;
    width: 100%;
`;

const SparkFooter = () => {
    const buttonProps = useSparkFooterLinks();

    return (
        <FooterContainer>
            <Footer maxWidth={SHELL_MAX_WIDTH} buttonProps={buttonProps} />
        </FooterContainer>
    );
};

export default SparkFooter;
